module.exports = __webpack_public_path__ + "img/travel.1cc631b2.png";